import React, { useEffect, useState } from "react";
//Bootstrap
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputGroup from "react-bootstrap/InputGroup";
//Fontawesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus } from "@fortawesome/free-solid-svg-icons";

export default function PotentialExpensesTableRows({
  id,
  row,
  addRow,
  removeRow,
  setField,
  potentialExpenseRows,
}) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (row.id === potentialExpenseRows[potentialExpenseRows.length - 1].id) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [potentialExpenseRows]);
  return (
    <tr key={id}>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <Form.Control
              type="text"
              className="expensesTableInput"
              placeholder="Title"
              value={row.title}
              onChange={(e) => setField("title", id, e.target.value)}
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={
                row.potentialExpenseOne === 0
                  ? undefined
                  : row.potentialExpenseOne
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialExpenseOne", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={
                row.potentialExpenseTwo === 0
                  ? undefined
                  : row.potentialExpenseTwo
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialExpenseTwo", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={
                row.potentialExpenseThree === 0
                  ? undefined
                  : row.potentialExpenseThree
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialExpenseThree", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={
                row.potentialExpenseFour === 0
                  ? undefined
                  : row.potentialExpenseFour
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialExpenseFour", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={
                row.potentialExpenseFive === 0
                  ? undefined
                  : row.potentialExpenseFive
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialExpenseFive", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={
                row.potentialExpenseSix === 0
                  ? undefined
                  : row.potentialExpenseSix
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialExpenseSix", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={
                row.potentialExpenseSeven === 0
                  ? undefined
                  : row.potentialExpenseSeven
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialExpenseSeven", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={
                row.potentialExpenseEight === 0
                  ? undefined
                  : row.potentialExpenseEight
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialExpenseEight", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={
                row.potentialExpenseNine === 0
                  ? undefined
                  : row.potentialExpenseNine
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialExpenseNine", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={
                row.potentialExpenseTen === 0
                  ? undefined
                  : row.potentialExpenseTen
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialExpenseTen", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={
                row.potentialExpenseEleven === 0
                  ? undefined
                  : row.potentialExpenseEleven
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialExpenseEleven", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td>
        <Form.Group>
          <InputGroup size="sm">
            <InputGroup.Text className="expensesTableInputGroup">
              £
            </InputGroup.Text>
            <Form.Control
              type="number"
              step="any"
              className="expensesTableInput"
              value={
                row.potentialExpenseTwelve === 0
                  ? undefined
                  : row.potentialExpenseTwelve
              }
              placeholder="Amt"
              onChange={(e) =>
                setField("potentialExpenseTwelve", id, e.target.value)
              }
            />
          </InputGroup>
        </Form.Group>
      </td>
      <td className="hideBorders col-1">
        {show && (
          <Button
            onClick={() => removeRow(id)}
            type="button"
            className="expensesNavcolour me-3"
          >
            <FontAwesomeIcon className="black" icon={faTrash} />
          </Button>
        )}

        {!show && (
          <Button
            onClick={() => removeRow(id)}
            type="button"
            className="expensesNavcolour"
          >
            <FontAwesomeIcon className="black" icon={faTrash} />
          </Button>
        )}

        {show && (
          <Button
            onClick={() => {
              addRow(id);
              setShow(false);
            }}
            type="button"
            className="expensesNavcolour"
          >
            <FontAwesomeIcon className="black" icon={faPlus} />
          </Button>
        )}
      </td>
    </tr>
  );
}
